<template>
    <main>
        <p>Loading...</p>
    </main>
</template>
<script>
export default {
    mounted(){
        window.location= "https://starbucksglobalacademy.com/coffee-academy/videos"
    }
}
</script>